// extracted by mini-css-extract-plugin
export default {"wrap":"DrawingsInfo_wrap__eHRz0","table":"DrawingsInfo_table__8RG-g","colDate":"DrawingsInfo_colDate__zoesA","colNote":"DrawingsInfo_colNote__jl9wO"};